
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo",
      function () {
        return require("private-next-pages/link-demo.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo"])
      });
    }
  